import React, { Component } from 'react';
import './WeightBenefitsTabs.css';
import _ from 'lodash';

class WeighBenefitsTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
        if(!_.isEmpty(this.props.benefitsData)){
            this.setState({
                data:this.props.benefitsData
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if(!_.isEmpty(nextProps.benefitsData)){
            this.setState({
                data : nextProps.benefitsData
            })
        }
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    benefitDataRendering(groupId, segmentId) {
        // console.log(this.props.competeData)

        // console.log('this.props.segmentation', this.props.segmentation.segmentationData);

        //debugger
        return this.props.competeData.map((i,key)=> {
            if (groupId === i.groupId && segmentId === i.segmentId){

                let benefitName;
                let benefitValue;
                this.props.benefits.benefitsLadderData.Items[0].data.map(item=>{
                    if(item.groupId === i.groupId){
                        benefitName = item.benefits.find(r => r.id === i.benefitId && r.important)
                    }
                })

                if(benefitName){
                    benefitValue = this.props.segmentation.segmentationData.Items[0].segmentation.find(r => r.benefitId === benefitName.id && r.segmentId === segmentId )
                }

                return (
                    <tr key={key}>
                        <td>
                            <div className='td-box'>
                                {benefitValue!==undefined && benefitValue.value }. {benefitName!==undefined && benefitName.name}
                            </div>
                        </td>
                        <td>
                            <div className='td-box'>
                                <input type='number' className='wt-input' value={i.wt} onChange={(e)=>this.props.onChangeWT(e, i)} />
                            </div>
                        </td>
                        <td className="opacity-cell">
                            <div className='td-box'>
                                <i className="fas fa-plus-circle"></i>
                            </div>
                        </td>
                        <td className="opacity-cell"><div className='td-box'></div></td>
                        <td className="opacity-cell"><div className='td-box'></div></td>
                        <td className="opacity-cell"><div className='td-box'></div></td>
                    </tr>
                )
            }
        });
    }

    countWT(groupId, segmentId) {
        let wt = 0;
        for (let i of this.props.competeData) {
            if (groupId === i.groupId && segmentId === i.segmentId) {
                wt += +i.wt
            }
        }
        return wt;
    }

    render() {

        let tabs = this.props.tabs.map((item,key) => {
            return (
                <li className="nav-item" key={`${item.groupId+`id`+item.segmentId}`} onClick={()=>{this.props.onTabChange(key)}}>
                    <a data-toggle="tab" className={key === this.props.tabStep ? "nav-link active show" :"nav-link"} href={`#${item.groupId+`id`+item.segmentId}`} aria-controls={`${item.groupId+`id`+item.segmentId}`} aria-selected="true">{item.groupName+` - `+item.segmentName} <i className="fa fa-minus minus-icon"
                    onClick={() => this.props.onDeleteTab(item)}
                ></i></a>
            </li>)
        });

        let tabsContent = this.props.tabs.map((tabItem, key) => {
            let countWT  = 0;
            const groupId = this.props.tabs.find(r => r.groupId === tabItem.groupId).groupId;
            const segmentId = this.props.tabs.find(r => r.segmentId === tabItem.segmentId).segmentId;

            return(
                <div id={groupId+`id`+segmentId} className={key === this.props.tabStep ? "tab-pane fade show active tabContentdiv compete-tab-content": "tab-pane fade tabContentdiv compete-tab-content"} role="tabpanel" key={key}>
                    <div className="row">
                        <div className="col-md-6">
                                <div className='compete-tab-content-box'>
                                    <div className="project-name">{
                                        (this.props.challengeStatementData && this.props.challengeStatementData.Count > 0 ) &&this.props.challengeStatementData.Items.map((name, key) => {
                                            return (
                                                <p key={key}>{name.chalange.horizon1.company}</p>
                                            )
                                        })
                                    }</div>
                                    <table className='compete-benefit-table'>
                                        <thead>
                                            <tr>
                                                <th>Benefits Sought</th>
                                                <th>WT</th>
                                                <th className="opacity-cell">Critical Capability</th>
                                                <th className="opacity-cell">CC WT</th>
                                                <th className="opacity-cell">Rating <br/> (1-10)</th>
                                                <th className="opacity-cell">Score</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.competeData &&  !_.isEmpty(this.props.benefitsData) && this.benefitDataRendering(groupId, segmentId)}
                                            <tr className='last-row'>
                                                <td></td>
                                                <td className='first-value' style={{textAlign: 'center'}}><strong>{ this.countWT(groupId, segmentId)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                        </div>
                    </div>
                </div>
            )
        })

        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    <li className="nav-item">
                        <a  id='plusTab' onClick={() => this.props.createWeight()}
                        ><i className="fa fa-plus plusbtn plus-icon"></i></a>
                    </li>
                    {tabs}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                </div>
            </div>
        )
    }
}
export default (WeighBenefitsTabs);



// WEBPACK FOOTER //
// ./src/components/AbilityToCompete/WeightBenefits/WeightBenefitsTabs/WeightBenefitsTabs.jsx